import { useTheme, FONT_FAMILY } from '@shopify/polaris-viz-core';
import { getFontSize } from '../../utilities/getFontSize.js';
import { estimateTrendIndicatorWidth } from './utilities/estimateTrendIndicatorWidth.js';
import { HEIGHT, NO_VALUE_WIDTH, NO_VALUE_ICON_HEIGHT, ICON_SIZE, TEXT_ICON_SPACING, Y_OFFSET } from './constants.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Svg } from './components/Svg/Svg.js';
import { ArrowUp } from './components/Arrows/ArrowUp.js';
import { ArrowDown } from './components/Arrows/ArrowDown.js';

const TREND_FONT_WEIGHT = 650;
function TrendIndicator({
  accessibilityLabel,
  direction = 'upward',
  tabIndex = -1,
  theme = 'Light',
  trend = 'neutral',
  value
}) {
  const selectedTheme = useTheme(theme);
  const fontSize = getFontSize();
  const svgProps = {
    accessibilityLabel,
    height: HEIGHT,
    tabIndex
  };
  if (value == null) {
    return /*#__PURE__*/jsx(Svg, {
      ...svgProps,
      width: NO_VALUE_WIDTH,
      children: /*#__PURE__*/jsx("path", {
        d: "M0.519531 1.79395H12.0039V0.249023H0.519531V1.79395Z",
        fill: selectedTheme.trendIndicator.neutral,
        transform: `translate(${(NO_VALUE_WIDTH - NO_VALUE_WIDTH) / 2}, ${(HEIGHT - NO_VALUE_ICON_HEIGHT) / 2})`
      })
    });
  }
  const {
    textWidth,
    totalWidth
  } = estimateTrendIndicatorWidth(value, fontSize, TREND_FONT_WEIGHT);
  return /*#__PURE__*/jsx(Svg, {
    ...svgProps,
    width: totalWidth,
    children: /*#__PURE__*/jsxs("g", {
      color: selectedTheme.trendIndicator[trend],
      children: [/*#__PURE__*/jsx("g", {
        transform: `translate(0, ${(HEIGHT - ICON_SIZE) / 2})`,
        children: direction === 'upward' ? /*#__PURE__*/jsx(ArrowUp, {}) : /*#__PURE__*/jsx(ArrowDown, {})
      }), /*#__PURE__*/jsx("text", {
        x: ICON_SIZE + TEXT_ICON_SPACING,
        y: (HEIGHT + Y_OFFSET) / 2,
        fontSize: fontSize,
        fill: "currentColor",
        fontWeight: TREND_FONT_WEIGHT,
        dominantBaseline: "middle",
        fontFamily: FONT_FAMILY,
        textRendering: "geometricPrecision",
        width: textWidth,
        children: value
      })]
    })
  });
}

export { TrendIndicator };
